module.exports = __webpack_public_path__ + "static/media/user1-darren-collins.14187a4d.jpg";